import type { Doc } from '~/types/user';

import { mobileCellStyle, mobileHeaderStyle } from './documentCell.css';
import { DocumentDownloadCell } from './DocumentDownloadCell';
import { DocumentExtensionCell } from './DocumentExtensionCell';
import { DocumentNameCell } from './DocumentNameCell';

type Props = {
  document: Doc;
};

export const DocumentMobileCell = ({ document }: Props) => {
  return (
    <div className={mobileCellStyle}>
      <div className={mobileHeaderStyle}>
        <DocumentNameCell name={document.title} />

        <DocumentExtensionCell extension={document.extension} />
      </div>

      <DocumentDownloadCell document={document} />
    </div>
  );
};
